import axios from "axios";
import { baseURL, adminAuthEndpoint } from "./config";

export const Login = async (email, password)=>{
    try{
        // UPDATED: Now using independent DataFeed.Server authentication (Option 1)
        const url = `${baseURL}/${adminAuthEndpoint}/login`;
        const body = {
            "email": email,
            "password": password
        };
        const resp = await axios.post(url, body);

        if(resp.status === 200){
            const responseData = resp.data;

            // DataFeed.Server returns: { token, userId, email, firstName, lastName, role }
            if (responseData && responseData.token && typeof responseData.token === 'string') {
                const userData = {
                    id: responseData.userId,
                    email: responseData.email,
                    firstName: responseData.firstName,
                    lastName: responseData.lastName,
                    role: responseData.role  // "MasterAdmin" or "Admin"
                };

                return {
                    token: responseData.token,
                    user: userData,
                    error: null
                };
            }

            return {token: null, error: "Login failed - unexpected response format. Response: " + JSON.stringify(responseData)};
        }
        return {token: null, error: resp?.status};

    }catch(ex){
        if(ex?.response){
            console.error('Login error:', ex?.response?.data);
            const errorMessage = ex?.response?.data?.message || ex?.response?.data?.error || JSON.stringify(ex?.response?.data);
            return {token: null, error: errorMessage};
        }
        console.error('Login exception:', ex);
        return {token: null, error: ex?.message || 'An unexpected error occurred'};
    }
}
export const Logout = async ()=>{}

export const GetUser = async (token) => {
    try {
        // UPDATED: Use DataFeed.Server independent auth endpoint
        const url = `${baseURL}/${adminAuthEndpoint}/me`;
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        };

        const response = await axios.get(url, config);
        return response.data;
    } catch (error) {
        console.error('Error fetching user data:', error);
        throw error.response?.data || error.message;
    }
};

export const Register = async(email, firstName, lastName, password, role = "Admin")=>{
    try{
        // UPDATED: Use DataFeed.Server independent auth endpoint
        // Only MasterAdmin can create users (requires authentication)
        const url = `${baseURL}/${adminAuthEndpoint}/create-user`;
        const body = {
            "email": email,
            "firstName": firstName,
            "lastName": lastName,
            "password": password,
            "role": role  // "Admin" or "MasterAdmin"
        };
        const resp = await axios.post(url, body);
        if(resp.status === 200){
            return {status: resp.status, message: resp.data.message, error: null};
        }
        return {status: resp.status, error: resp?.status};

    }catch(ex){
        if(ex?.response){
            console.error('Register error:', ex?.response?.data);
            const errorMessage = ex?.response?.data?.message || ex?.response?.data?.error || JSON.stringify(ex?.response?.data);
            return {error: errorMessage};
        }
        console.error('Register exception:', ex);
        return { error: ex?.message || 'An unexpected error occurred'};
    }

}
